import { Section, SectionProps, tokensRaw } from '@vp/swan';
import styled from 'styled-components';

const DrawerContentContainer = styled(Section)`
    height: 100%;
    padding: ${tokensRaw.SwanBaseSpace200};
`;

interface DrawerContentProps extends SectionProps {
    children: React.ReactNode;
    'aria-label'?: string;
}

export const DrawerContent: React.FC<DrawerContentProps> = ({ children, ...props }) => {
    return <DrawerContentContainer {...props}>{children}</DrawerContentContainer>;
};
